import { FC } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text, Truncated } from '@frontend/design-system';
import { AppointmentDateFormat } from '../../constants';
import { ScheduledAppointmentData } from '../../types';
import { formatAppointmentDate, getAppointmentTypeIcon } from '../../utils';
import { GlassCard } from '../glass-card';

interface AppointmentCardProps extends ScheduledAppointmentData {
  containerStyles?: Interpolation<Theme>;
}

export const AppointmentCard: FC<AppointmentCardProps> = ({ containerStyles, title, type, date }) => {
  return (
    <GlassCard containerStyles={[styles.container, containerStyles]}>
      <Icon name={getAppointmentTypeIcon(type)} css={{ color: theme.colors.indigo50 }} />
      <div css={styles.content}>
        <div css={styles.title}>
          <Truncated as={Text} size='medium' weight='bold' css={{ maxWidth: '124px' }}>
            {title}
          </Truncated>
          {/* TODO: Milind - add download .ics action later when appointment end date is available */}
          {/* <Icon name='plus-small' color='subdued' /> */}
        </div>

        {date && (
          <Text size='small' color='subdued'>
            {formatAppointmentDate(date, AppointmentDateFormat.ALTERNATE)}
          </Text>
        )}
      </div>
    </GlassCard>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(1)};
    border-color: ${theme.colors.indigo50};
    width: 188px;
    flex-shrink: 0;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    flex: 1;
  `,
  title: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing(1)};
  `,
};
